import FaqPageHandler from '@/router/handlers/faq-page-handler';
import PageHandler from '@/router/handlers/page.handler';
import SpecialtyPageHandler from '@/router/handlers/specialty-page.handler';
import {
  buildGetStaticPaths,
  buildGetStaticProps,
  buildPage,
} from '@/router/ssg.router';
import { RouteHandlerProps } from '@/router/types.router';

export enum HomeRouterHandleType {
  Page = 'page',
  SpecialtyPage = 'specialty-page',
  FaqPage = 'faq-page',
}

const homeHandlers: Record<HomeRouterHandleType, RouteHandlerProps> = {
  [HomeRouterHandleType.FaqPage]: FaqPageHandler,
  [HomeRouterHandleType.SpecialtyPage]: SpecialtyPageHandler,
  [HomeRouterHandleType.Page]: PageHandler,
};

const homeSlugRouter: RouteHandlerProps = {
  getStaticPaths: buildGetStaticPaths(homeHandlers),
  getStaticProps: buildGetStaticProps(homeHandlers),
  Component: buildPage(homeHandlers),
};

export const getStaticProps = homeSlugRouter.getStaticProps;
export const getStaticPaths = homeSlugRouter.getStaticPaths;

export default homeSlugRouter.Component;
